import classNames from 'classnames';
import { autobind } from 'core-decorators';
import PropTypes from 'prop-types';
import { Component, Fragment } from 'react';
import styles from './styles.module.css';

@autobind
export default class Input extends Component {
    static propTypes = {
        color: PropTypes.oneOf([
            'gray-opacity',
            'white',
            'cultivio',
            'expertobayer',
            'latijereta',
            'agroeste',
            'agroceres',
            'md',
            'fieldview',
        ]),
        appearance: PropTypes.oneOf(['fill', 'outline', 'noborder']),
        size: PropTypes.oneOf(['sm', 'md', 'lg', 'xl']),
        type: PropTypes.string,
        step: PropTypes.number,
        placeholder: PropTypes.string,
        prefix: PropTypes.string,
        suffix: PropTypes.string,
        min: PropTypes.number,
        max: PropTypes.number,
        autoFocus: PropTypes.bool,
        shadow: PropTypes.bool,
        disabled: PropTypes.bool,
        fullWidth: PropTypes.bool,
        error: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        onChange: PropTypes.func.isRequired,
        onFocus: PropTypes.func,
        onBlur: PropTypes.func,
        onKeyDown: PropTypes.func,
        onReset: PropTypes.func,
        title: PropTypes.string,
        titleStyles: PropTypes.string,
        extraClass: PropTypes.string,
        iconPassword: PropTypes.bool,
        name: PropTypes.string,
    };

    static defaultProps = {
        size: 'md',
        type: 'text',
    };

    state = {
        focused: false,
        type: 'password',
    };

    setInputRef(input) {
        this.input = input;
    }

    handleFocus() {
        this.setState({ focused: true });
        if (this.props.onFocus) this.props.onFocus();
    }

    handleBlur() {
        this.setState({ focused: false });
        const { value, type } = this.props;
        if (type === 'text' && !!value) this.props.onChange(value.trim());
        if (this.props.onBlur) this.props.onBlur();
    }

    handleChange(event) {
        this.props.onChange(event.target.value, event.target.name);
    }

    handleRootClick() {
        this.input.focus();
    }

    handleOnKeyPress(e) {
        if (e.keyCode === 13) {
            e.target.blur();
        }
        if (this.props.onKeyDown) {
            this.props.onKeyDown(e);
        }
    }

    handleClickShowPassword = () =>
        this.setState(({ type }) => ({
            type: type === 'text' ? 'password' : 'text',
        }));

    render() {
        const className = classNames(
            styles.root,
            this.props.extraClass,
            this.props.bgColor && styles[`bg-color-${this.props.color}`],
            !this.props.bgColor && styles[`color-${this.props.color}`],
            styles[`appearance-${this.props.appearance}`],
            styles[`size-${this.props.size}`],
            this.props.disabled && styles.disabled,
            this.props.shadow && styles.shadow,
            this.props.fullWidth && styles.fullWidth,
            !!this.props.error && styles.error,
            this.state.focused && styles.focused
        );

        return (
            <Fragment>
                {this.props.title && <div className={this.props.titleStyles}>{this.props.title}</div>}
                <div className={className} onClick={this.handleRootClick}>
                    {this.props.prefix && <span>{this.props.prefix}</span>}
                    <input
                        ref={this.setInputRef}
                        type={this.props.iconPassword ? this.state.type : this.props.type}
                        step={this.props.step}
                        placeholder={this.props.placeholder}
                        disabled={this.props.disabled}
                        value={this.props.value}
                        min={this.props.min}
                        max={this.props.max}
                        autoFocus={this.props.autoFocus}
                        onChange={this.handleChange}
                        onFocus={this.handleFocus}
                        onBlur={this.handleBlur}
                        onKeyDown={this.handleOnKeyPress}
                        name={this.props.name}
                    />
                    {this.props.suffix && <span>{this.props.suffix}</span>}
                    {this.props.value !== undefined && String(this.props.value).length > 0 && this.props.onReset && (
                        <span className={styles.reset} onClick={this.props.onReset}>
                            <i className='material-icons'>clear</i>
                        </span>
                    )}
                    {this.props.iconPassword && (
                        <span className={styles.reset} onClick={this.handleClickShowPassword}>
                            <i className='material-icons'>
                                {this.state.type === 'text' ? 'visibility_off' : 'visibility'}
                            </i>
                        </span>
                    )}
                    {this.props.editIcon && (
                        <div className={styles.edit}>
                            <span className='material-icons'>drive_file_rename_outline</span>
                        </div>
                    )}
                </div>
                {Boolean(this.props.error) && typeof this.props.error === 'string' && (
                    <div className={styles.errorMessage}>{this.props.error}</div>
                )}
            </Fragment>
        );
    }
}
